import * as z from "zod";

export const ProductSchema = z.object({
  Id: z.guid(),
  Name: z.string(),
  Price: z.int().positive(),
  Quantity: z.int().positive(),
});
